import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/footer";
import SeoHead from "../components/SeoHead";

const NotFound = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
        // Scroll to top on mount
        window.scrollTo(0, 0);
        if (window.lenis) {
            window.lenis.scrollTo(0, { immediate: true });
        }
    }, []);

    return (
        <div className="min-h-screen flex flex-col bg-background selection:bg-primary selection:text-white">
                        <SeoHead
                            title="Page Not Found | QBITS9"
                            description="The page you are looking for might have been removed, had its name changed, or is temporarily unavailable."
                            canonicalPath="/404"
                            noindex
                        />

            <Header />

            <main className="flex-grow flex items-center justify-center pt-32 pb-20 px-6">
                <div className={`max-w-4xl w-full text-center transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>

                    {/* 404 Number with subtle float animation */}
                    <div className="relative inline-block">
                        <div className="text-[120px] md:text-[200px] font-unbounded font-black leading-none text-primary/10 select-none animate-pulse">
                            404
                        </div>
                        <div className="absolute inset-0 flex items-center justify-center">
                            <h1 className="text-4xl md:text-6xl font-unbounded font-bold text-blue tracking-tight">
                                Oops! Page not found.
                            </h1>
                        </div>
                    </div>

                    <div className="mt-8 space-y-6">
                        <p className="max-w-lg mx-auto text-lg text-grey font-poppins">
                            The page you're looking for doesn't exist or has been moved.
                            Don't worry, we'll help you find your way back.
                        </p>
                    </div>

                    {/* Action Buttons */}
                    <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
                        <Link
                            to="/"
                            className="w-full sm:w-auto relative overflow-hidden flex items-center justify-center bg-primary px-10 py-4 rounded-full group transition-transform active:scale-95"
                            aria-label="Go to homepage"
                        >
                            <span className="relative z-10 text-white font-unbounded font-medium">
                                Go Home
                            </span>
                            <span className="absolute inset-1/2 w-0 h-0 bg-secondary rounded-full transition-all duration-700 ease-in-out group-hover:w-[20rem] group-hover:h-[20rem] -translate-x-1/2 -translate-y-1/2" />
                        </Link>

                        <Link
                            to="/#services"
                            className="w-full sm:w-auto relative overflow-hidden flex items-center justify-center border-2 border-primary/20 hover:border-primary px-10 py-4 rounded-full group transition-all active:scale-95"
                            aria-label="View our services"
                        >
                            <span className="relative z-10 text-primary group-hover:text-primary font-unbounded font-medium">
                                View Services
                            </span>
                        </Link>

                        <a
                            href="/contact"
                            target="_blank"
                            rel="noreferrer"
                            className="w-full sm:w-auto text-blue hover:text-primary font-unbounded font-medium underline underline-offset-8 decoration-primary/30 hover:decoration-primary transition-all p-4"
                            aria-label="Contact support"
                        >
                            Contact Support
                        </a>
                    </div>

                    {/* Quick Links for Crawl Flow */}
                    <div className="mt-20 pt-10 border-t border-blue/5">
                        <p className="text-sm font-unbounded text-grey/60 uppercase tracking-widest mb-6">
                            Maybe you were looking for
                        </p>
                        <nav className="flex flex-wrap justify-center gap-x-8 gap-y-4">
                            <Link to="/blog" className="text-blue hover:text-primary font-poppins font-medium transition-colors">Blog</Link>
                            <Link to="/#our_clients" className="text-blue hover:text-primary font-poppins font-medium transition-colors">Our Clients</Link>
                            <Link to="/#faqs" className="text-blue hover:text-primary font-poppins font-medium transition-colors">FAQs</Link>
                        </nav>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default NotFound;
